import Typography from 'material-ui/Typography'
import * as React from 'react'
import { Link } from 'react-router'
import { BigGreenButton } from './BigGreenButton'
import { BlueGreenBar } from './BlueGreenBar'

interface Props {
    accent?: boolean
    navigateTo: (location: string) => void
}

export class Footer extends React.Component<Props, {}> {

    render() {
        return (
            <footer style={{textAlign: 'center', margin: 0, padding: 0}}>
                <BlueGreenBar fullWidth/>
                <div style={{margin: '0 auto', padding: '60px 0 30px'}}>
                    <div>
                        <Typography type='display3' style={{lineHeight: '1.5em', fontSize: 32}}>
                            Got an Idea (or 20)?
                        </Typography>
                        <Typography
                            type='display4'
                            style={{fontSize: 64, color: this.props.accent ? '#1D9ED8' : '#404040'}}
                        >
                            WE CAN HELP.
                        </Typography>
                        <div style={{margin: '50px 0 80px'}}>
                            <BigGreenButton text='Get in Touch →' onClick={() => this.props.navigateTo('/contact')}/>
                        </div>
                    </div>
                    <div>
                        <Link to='/' onClick={() => window.scroll(0, 0)}>
                            <img src='/img/Logo.svg' alt='logo' style={{margin: 10, height: 58}}/>
                        </Link>
                        <Typography type='caption'>
                            ©2017 Twenty Ideas, Inc.
                        </Typography>
                    </div>
                </div>
            </footer>
        )
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/components/Footer.tsx